import { createOrEditNonPatientActivityType } from '../../../actions/areas/admin/commandActions';
import globals from '../../../globals/communityGlobals';

const locale = globals.getAreas(['nonPatientActivityTypes', 'error']);

export const eventHandlers = (state, setState, auth) => ({
  refreshTable: () => setState({ ...state, forceReload: !state.forceReload }),
  handleSidePanel: show => setState({ ...state, showCreatePanel: show }),
  setSelectedModel: selectedActivity => setState({ ...state, selectedActivity, showEditPanel: true }),
  submitAction: model => {
    const callback = () =>
      setState({ ...state, forceReload: !state.forceReload, showCreatePanel: false, showEditPanel: false });
    createOrEditNonPatientActivityType(auth, model, callback);
  },
  closePanels: () => setState({ ...state, showCreatePanel: false, showEditPanel: false }),
  locale,
  addButtonText: locale.getMsg('addButtonText'),
});
